export default __webpack_public_path__ + "static/media/bg.34707baa.svg";